import React from 'react';
import { Box, Text, Image, HStack,  Button } from '@chakra-ui/react';

const HowItWorks = () => {
  return (
    <Box w="full" h="100%" bg={['#F5F8FF','#fff']} p={['2rem', '3rem', "4rem",'6rem']}>
      <Text
        color="#A0A4A8"

        fontWeight="500"
        fontSize="18px"
        textTransform="capitalize"
      >
        How it Works
      </Text>
      <Text
        fontWeight="500"
        fontFamily='Duplicate Sans'
        display="block"
        w={['85%','75%','75%',"65%"]}
        mt="1rem"
        lineHeight={['32px','32px','40px',"72px"]}
        fontSize={['1.5rem','1.74rem','1.75rem',"3rem"]}
      >
        Make payment just with the <br />
        tap of a finger
      </Text>
      <Box
        mt="3rem"
        display="flex"
        alignItems="base-start"
        gap='8'
        justifyContent='space-between'
        flexDirection={['column','column','column', 'row']}
      >
        <Box w={['100%','100%','100%',"50%"]} display='flex' fontFamily='Work Sans' flexDirection='column' justifyContent='space-evenly'>
          <Box display="flex" justifyContent='right' alignItems="base-start">
            <Text color="#246BFD" fontWeight="500" fontSize={['1.35rem','1.35rem','1.35rem',"2rem"]} w="15%">
              #1
            </Text>
            <Box w="85%">
              <Text color="#246BFD" fontWeight="500" fontFamily='Duplicate Sans' fontSize={['1.35rem','1.35rem','1.35rem',"2rem"]}>
                Create a NeemblePay Account
              </Text>
              <Text color="#445368" mt='1rem' lineHeight="28px" textAlign="justify">
                Lorem ipsum dolor sit amet, consectetur adipiscing. Etiam eu
                turpis molestie, dictum est a, mattis dignissim, metus nec
                fringilla accumsan, risus.
              </Text>
            </Box>
          </Box>
          <Box display="flex" mt='3rem' justifyContent='left' alignItems="base-start">
            <Text color="#445368" fontWeight="500" fontSize="1.25rem" w="15%">
              #2
            </Text>
            <Box w="85%">
              <Text color="#445368" fontFamily='Duplicate Sans' fontWeight="500" fontSize="1.25rem">
              Link Bank Account & Cards
              </Text>
              <Text color="#445368" lineHeight="28px" mt='1rem' textAlign="justify">
                Lorem ipsum dolor sit amet, consectetur adipiscing. Etiam eu
                turpis molestie, dictum est a,
              </Text>
            </Box>
          </Box>
          <Box display="flex" mt='2rem' justifyContent='left' alignItems="base-start">
            <Text color="#445368" fontWeight="500" fontSize="1.25rem" w="15%">
              #3
            </Text>
            <Box w="85%">
              <Text color="#445368" fontFamily='Duplicate Sans' fontWeight="500" fontSize="1.25rem">
              Initiate Withdrawal Transaction
              </Text>
              <Text color="#445368" lineHeight="28px" mt='1rem' textAlign="justify">
                Lorem ipsum dolor sit amet, consectetur adipiscing. Etiam eu
                turpis molestie, dictum est a, mattis dignissim,
              </Text>
            </Box>
          </Box>
          <Box display="flex" mt='2rem' justifyContent='left' alignItems="base-start">
            <Text color="#445368" fontWeight="500" fontSize="1.25rem" w="15%">
              #4
            </Text>
            <Box w="85%">
              <Text color="#445368" fontWeight="500"fontFamily='Duplicate Sans' fontSize="1.25rem">
              Biometric Verification
              </Text>
              <Text color="#445368" lineHeight="28px"mt='1rem' textAlign="justify">
                Lorem ipsum dolor sit amet, consectetur adipiscing. Etiam eu
                turpis molestie, dictum est a, mattis dignissim,
              </Text>
            </Box>
          </Box>
        </Box>
        <Box w={['100%','100%','100%',"50%"]} display={['none','block']} >
          <Image boxSize={['100%','100%','50%',"100%"]}m='auto' src="/worksBox.png" alt="" />
        </Box>
      </Box>
      <HStack mt="3rem" mb={['1rem','']} gap={['4', '2', '2', '2']}>
          <Button
            href="#services"
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontFamily='Work Sans'
            display='flex'
            alignItmes='center'
            fontSize={['.7rem', '1rem', '.7rem', '.9rem']}
            color="#fff"
            bg="#246BFD"
            p={['.75rem 1.5rem', ' 16px, 24px, 16px, 24px', ' 16px, 24px, 16px, 24px','16px, 24px, 16px, 24px']}
            w={['130px','160px','160px','160px']} h={['44px','50px','50px','54px']}
            borderRadius="8px"
            fontWeight="500"
            _active={{ color: '#000' }}
          >
            Get Started&nbsp;{' '}
            <Image
              src="/hero_arrow.png"
              _hover={{ marginLeft: '.2rem' }}
            boxSize='1rem'
              alt="socials"
            />
          </Button>
          <Button
            display={['flex','flex','flex', 'flex']}
            href="#services"
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontSize={['.7rem', '.7rem', '.7rem', '1rem']}
            color="#000"
            bg="#fff"
            fontFamily='Work Sans'
            p=".15rem 1rem"
            borderRadius="16px"
            fontWeight="500"
            _active={{ color: '#000' }}
          >
            <Image src="/play.svg" alt="socials" />
            &nbsp;See a demo
          </Button>
        </HStack>
    </Box>
  );
};

export default HowItWorks;
